import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import * as serviceWorker from './serviceWorker';
import store from './store';
import App from './view/homepage/container';
import axios from 'axios';

axios.get(`${process.env.PUBLIC_URL}/data/webconfig.json`).then((res) => {
    window.config = res.data;
    require(`./themes/${config.theme ?? "classic"}.css`);
    document.title = window.config.app_name;

    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>
        , document.getElementById('root'));
})


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// serviceWorker.register();

